import React, {useState} from "react";
import {BsSendFill} from "react-icons/bs";

const WHATSAPP_NUMBER = "919043635749";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        project: "",
        message: "",
    });
    const [sending, setSending] = useState(false);

    const handleInput = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({...prev, [name]: value}));
    };

    const buildWhatsAppUrl = () => {
        const lines = [
            "*New Enquiry from Pivot TechX Website*",
            "",
            `*Name:* ${formData.name}`,
            `*Email:* ${formData.email}`,
            `*Phone:* ${formData.phone}`,
            `*Project Type:* ${formData.project}`,
            "",
            "*Message:*",
            formData.message,
        ];
        return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(lines.join("\n"))}`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSending(true);
        window.open(buildWhatsAppUrl(), "_blank");
        setTimeout(() => {
            setFormData({name: "", email: "", phone: "", project: "", message: ""});
            setSending(false);
        }, 500);
    };

    const btnStyle = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #0a0c3e, #320545)",
        border: "none",
        color: "#fff",
        fontSize: "1rem",
        fontWeight: 600,
        padding: "12px 28px",
        borderRadius: "30px",
        cursor: "pointer",
        boxShadow: "0 6px 18px rgba(50,5,69,0.4)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
    };

    const inputStyle = {
        display: "block",
        width: "100%",
        background: "#ffffff",
        border: "2px solid transparent",
        borderBottom: "2px solid rgba(255,255,255,0.6)",
        borderRadius: "10px",
        color: "#0a0c3e",
        padding: "12px 14px",
        fontSize: "0.95rem",
        outline: "none",
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    };

    const selectStyle = {
        ...inputStyle,
        cursor: "pointer",
        appearance: "none",
        WebkitAppearance: "none",
        backgroundImage:
            "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23320545' d='M6 8L0 0h12z'/%3E%3C/svg%3E\")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 14px center",
        paddingRight: "34px",
    };

    return (
        <div id="contact" className="contact-wrap">
            <div className="contact-data container-fluid py-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-5">
                            <p className="tag">Contact Us</p>
                            <h2 className="text-white">Let's build something great together</h2>
                            <p className="mt-3">
                                Have a project in mind? Drop us your requirements and our team will
                                get back to you on WhatsApp right away.
                            </p>
                            <div className="mt-4">
                                <p><strong>WhatsApp / Phone:</strong> +91 90436 35749</p>
                                <p><strong>Email:</strong> pivottechx@gmail.com</p>
                            </div>
                        </div>

                        <div className="col-lg-7">
                            <form
                                onSubmit={handleSubmit}
                                className="contact-form"
                                style={{background: "rgba(255,255,255,0.08)", padding: "32px", borderRadius: "16px"}}
                            >
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="text-white" style={{fontSize: "0.85rem"}}>Your Name *</label>
                                        <input type="text" name="name" required value={formData.name}
                                               onChange={handleInput} style={inputStyle} placeholder="Enter your name"/>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="text-white" style={{fontSize: "0.85rem"}}>Phone *</label>
                                        <input type="tel" name="phone" required value={formData.phone}
                                               onChange={handleInput} style={inputStyle} placeholder="Enter your phone"/>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="text-white" style={{fontSize: "0.85rem"}}>Email *</label>
                                        <input type="email" name="email" required value={formData.email}
                                               onChange={handleInput} style={inputStyle} placeholder="Enter your email"/>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="text-white" style={{fontSize: "0.85rem"}}>Project Type</label>
                                        <select name="project" value={formData.project} onChange={handleInput}
                                                style={selectStyle}>
                                            <option value="">Select a service</option>
                                            <option>Web Development</option>
                                            <option>Mobile App Development</option>
                                            <option>AI / Automation</option>
                                            <option>E-Commerce</option>
                                            <option>DevOps</option>
                                            <option>UI/UX Design</option>
                                            <option>Other</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <label className="text-white" style={{fontSize: "0.85rem"}}>Message *</label>
                                        <textarea name="message" required rows="4" value={formData.message}
                                                  onChange={handleInput} style={inputStyle} placeholder="Tell us about your project..."/>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" disabled={sending} className="contact-btn" style={btnStyle}
                                                onMouseEnter={(e) => {e.currentTarget.style.transform = "translateY(-2px)"}}
                                                onMouseLeave={(e) => {e.currentTarget.style.transform = "translateY(0)"}}>
                                            <BsSendFill size={16} style={{marginRight: 8}}/>
                                            {sending ? "Opening WhatsApp..." : "Send to WhatsApp"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
